<template>
<el-form  :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
  <div class="bottom" style="height:50px;line-height:50px;border-bottom: 1px solid #eee;">
   <span style="display:line-block;margin-left:30px;" >{{ modifyType==1?'修改密码':'修改手机' }}</span>
   <span style="display:block;width:70px;height:2px;background:#F56C6C;margin-left:22px;"></span>
  </div>
  <div v-if="modifyType==1">
    <el-form-item style="margin-top:30px;" label="手机号" prop="pass">
      <el-input style="width:420px;" :disabled="true"  v-model="ruleForm.pass" autocomplete="off"></el-input>
      <span ref="oldCode" @click="xgmmCode()" class="classCode">获取验证码</span>
    </el-form-item>
    <div class="error">
      <el-form-item label="验证码" prop="oldCode">
        <el-input style="width:420px;"  v-model="ruleForm.oldCode" placeholder="请输入验证码" autocomplete="off"/>
        <el-input style="position: fixed; bottom: -9999px;" autocomplete="off"/>
      </el-form-item>
      
      <el-form-item label="原密码" prop="Original">
        <el-input type="password" autocomplete="off" style="position: fixed; bottom: -9999px;"/>
        <el-input type="password" v-model="ruleForm.Original " placeholder="请输入原密码" autocomplete="off" style="width:420px;"/>
      </el-form-item>
      <el-form-item label="新密码" prop="newNum">
        <el-input type="password" v-model="ruleForm.newNum" placeholder="请输入新密码" autocomplete="off" style="width:420px;"/>
      </el-form-item>
      <el-form-item label="确认新密码" prop="makesure">
        <el-input type="password"  v-model.number="ruleForm.makesure" placeholder="请确认新密码" style="width:420px;"/>
      </el-form-item>
    </div>
  </div>
  <div v-else>
    <el-form-item style="margin-top:30px;" label="原手机号码" prop="pass">
      <el-input style="width:420px;" v-model="ruleForm.originalPhone" disabled/>
    </el-form-item>
    <el-form-item label="登录密码" prop="loginPassword">
      <el-input v-model="ruleForm.loginPassword" placeholder="请输入登录密码" style="width:420px;"/>
    </el-form-item>
    <el-form-item style="margin-top:30px;" label="新手机号" prop="newPhone">
      <el-input style="width:420px;" v-model="ruleForm.newPhone" placeholder="请输入新手机号"/>
      <button @click.prevent="xgphoneCode()" class="codenumber" :class="{ 'active': countdownActive }">
        {{ countdownActive ? `${countdown} 秒` : '获取验证码' }}
      </button>
    </el-form-item>
    <el-form-item label="验证码" prop="newCode">
      <el-input style="width:420px;"  v-model="ruleForm.newCode" placeholder="请输入验证码" autocomplete="off"/>
      <el-input style="position: fixed; bottom: -9999px;" autocomplete="off"/>
    </el-form-item>
  </div>
  <el-form-item style="padding: 20px 0 50px 0;">
    <el-button type="danger" @click="submitForm(modifyType)">提交</el-button>
    <el-button type="danger" @click="resetForm('ruleForm')">重置</el-button>
  </el-form-item>
</el-form> 
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { codenum,ChangePassword } from "../../api/api";
import { toolsSendcode, changephone } from "../../api/newOss";
 export default {
    mixins: [alertTrends],
    data() {
      var checkACode = (rule, value, callback) => {
        if (value === "") {
          return callback(new Error('验证码不能为空'));
        }
      
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入原密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !=this.ruleForm.newNum) {
          callback(new Error('两次输入密码不一致!'));
          console.log(value,this.ruleForm.newNum)
        } else {
          callback();
        }
      };
       var validatePass3 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码'));
        }  else {
          callback();
        }
      };
      return {
        ruleForm: {
          pass: '',
          checkPass: '',
          age: '',
          oldCode:'',
          Original:'',
          newNum : '',
          makesure:"",
          off:true,
          timing : null,
          
          originalPhone: '',
          loginPassword: '',
          newPhone: '',
          newCode: '',
          
        },
        rules: {
          Original  : [
            { validator: validatePass, trigger: 'change' }
          ],
          newNum  : [
            { validator: validatePass3, trigger: 'blur' }
          ],
          makesure: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          oldCode: [
            { validator: checkACode, trigger: 'change' }
          ]
        },
        modifyType: '', // 区分模块
        
        countdown: 60, // 倒计时初始秒数
        countdownActive: false, // 倒计时是否正在进行
        timer: null, // 用于存储定时器的引用
        
      };
    },
    methods: {
      // 提交
      submitForm(type) {
        console.log(type,'提交类型')
        if(type==1){
          let obj = {
            phone : this.ruleForm.pass,
            smsCode : this.ruleForm.oldCode,
            oldpwd : this.ruleForm.Original,
            newpwd : this.ruleForm.newNum
          }
          ChangePassword(obj).then(data=>{
            if (data.ResultCode == 1) {
              // localStorage.setItem("passId", this.ruleForm.newNum); // 新密码
              // console.log(localStorage.passId,'新密码');
              this.showAlert('修改成功', 'success');
              this.ruleForm.oldCode=""
              this.ruleForm.Original=""
              this.ruleForm.newNum=""
              this.ruleForm.makesure=""
              this.$router.replace("/welcome"); // 欢迎首页
            }else{
              this.$swal({
                type: "warning",
                text: data.ResultMsg,
              });
            }
          })
        }else{
          if (this.ruleForm.loginPassword == '') {
            this.showAlert('请输入登录密码');
            return false;
          }
          if (this.ruleForm.newPhone == "") {
            this.showAlert('请输入新手机号');
            return false;
          }
          if (this.ruleForm.newCode == "") {
            this.showAlert('请输入验证码');
            return false;
          }
          let obj = {
            pwd : this.ruleForm.loginPassword, // 登录密码
            code : this.ruleForm.newCode, // 手机验证码 接口调用：/api/tools/sendcode type=17
            phone : this.ruleForm.newPhone, // 新手机号
          }
          changephone(obj).then(data=>{
            if (data.resultCode == 1) {
              this.showAlert('修改成功', 'success');
              this.ruleForm.oldCode=""
              this.ruleForm.Original=""
              this.ruleForm.newNum=""
              this.ruleForm.makesure=""
              this.$router.replace("/login"); // 欢迎首页
            }else{
              this.$swal({
                type: "warning",
                text: data.resultMsg,
              });
            }
          })
        }
      },
      // 重置
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.ruleForm.pass = this.$cookie.get("Phone")
      },
      // 修改密码-验证码
      xgmmCode(){
        let obj = {
          phone:this.ruleForm.pass,
          type:5
        }
        codenum(obj).then(data=>{
          // console.log(data)
          if(data.ResultCode==1){
            // var span = document.getElementById("countdown")

            let maxtime = 60; //，按秒计算，自己调整!
            let CountDown=()=> {
              if (maxtime >= 0) {
                this.$refs.oldCode.style.background = "#8e8e8e"
                // var minutes = Math.floor(maxtime / 60)>10?Math.floor(maxtime / 60):"0"+Math.floor(maxtime / 60);
                let seconds = Math.floor(maxtime % 60)>10?Math.floor(maxtime % 60):"0"+Math.floor(maxtime % 60);
                let msg =   seconds + "秒"
              
                this.$refs.oldCode.innerHTML = msg;
                --maxtime;
                  
              }else{
                // this.ruleForm.off  = true
                clearInterval(this.ruleForm.timing);
                this.ruleForm.timing = null;
                this.$refs.oldCode.style.background = "#F56C6C"
                this.$refs.oldCode.innerHTML = "获取验证码"
                this.$emit('update:timeShow',true)
              }
            }
            this.ruleForm.timing = setInterval(CountDown, 1000);
            
          }
        })
      },
      // 修改手机 - 获取验证码
      xgphoneCode() {
        if (this.countdownActive) return; // 如果倒计时正在进行，不执行操作
        if (!this.ruleForm.newPhone) {
          this.showAlert('请先输入新手机号');
          return false;
        }
        this.countdownActive = true;
        var obj = {
          type: 17,
          mobile: this.ruleForm.newPhone, // 手机号
        };
        toolsSendcode(obj).then(data => {
          if (data.resultCode == 1) {
            this.$message({
              message: data.resultObj,
              type: "success"
            });
            this.timer = setInterval(() => {
              if (this.countdown === 0) {
                clearInterval(this.timer); // 清除定时器
                this.countdownActive = false;
                this.countdown = 60; // 重置倒计时
              } else {
                this.countdown--;
              }
            }, 1000);
          } else {
            return false;
          }
        }).catch(error => {
          // console.error("获取data失败:", error);
          clearInterval(this.timer); // 清除定时器
          this.countdownActive = false;
          return false;
        });
      },
    },
    beforeDestroy() {
    clearInterval( this.ruleForm.timing);
    },
    created(){
      this.modifyType = this.$route.query.type; // 区分 修改密码 还是 修改手机
      // 监听路由变化
      this.$watch('$route', (newRoute) => {
        this.modifyType = newRoute.query.type;
        console.log(this.modifyType, '路由变化后的类型');
      });
      
      this.ruleForm.pass =  this.$cookie.get("Phone");
      this.ruleForm.originalPhone = this.$cookie.get("Phone");
    }
  }
</script>
<style scoped>
.demo-ruleForm{
  margin:10px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
}
.bottom{
  border-bottom: 1px solid #eeeeee;
}
.color{
  color: #F56C6C;
  background:#fff;
  border:1px solid #F56C6C;
  margin-top:20PX;
}
.color :hover{
  background: #F56C6C
}
.classCode{
  font-size:20px;
  width:90px;
  text-align: center;
  display: inline-block;
  background:#F56C6C;
  color:#fff;
  margin-left:10px;
  border-radius: 5px;
  font-size:12px;
  cursor: pointer;
}
/* 获取验证码 */
.codenumber {
  width: 90px;
  height: 40px;
  border: none;
  border-radius: 5px;
  font-size:12px;
  color: #fff;
  cursor: pointer;
  background:#F56C6C;
}
.codenumber.active {
  border: 1px solid #bfbfbf;
  background:#fff;
  color: #888;
}
</style>



// WEBPACK FOOTER //
// modify.vue?731731ed